const loginFormStyles = theme => ({
  headerImage: {
    textAlign: 'center'
  },
  forgot: {
    textAlign: 'center',
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.utils.shadeColor(theme.palette.primary.main, -15)
    }
  },
  title: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 900,
    marginTop: theme.spacing.unit * 2
  },
  input: {
    fontSize: 16
  },
  image: {
    width: 100,
    [theme.breakpoints.down('sm')]: {
      width: 50
    }
  }
});

export default loginFormStyles;
